import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import { grey } from "@mui/material/colors";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import React from "react";

const CardExpanded = styled((props) => {
  const {expand, ...other} = props;
  return <Card {...other} />;
})(({theme, expand}) => ({
  "&.MuiPaper-root": {
    border: !expand ? "1px solid transparent" : "1px solid #7461da",
    transition: theme.transitions.create("border", {
      duration: theme.transitions.duration.shortest,
    }),
  },
}));

export const CollapseImageLeftTextRight = ({program, children, ...props}) => {
  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = (newStatus) => {
    setExpanded(newStatus);
  };

  const childrenWithEvents = React.Children.map(children, child => React.cloneElement(child, { onExpandChanged: handleExpandClick}));

  return (
    <CardExpanded
      expand={expanded}
      square={false}
      elevation={0}
      sx={{
        "&.MuiPaper-root": {
          "& > .MuiButtonBase-root": {
            padding: 0,
            "& .MuiAccordionSummary-content": {
              margin: 0,
            },
          },
          "&:not(:last-of-type)": {
            mb: 1,
          },
          "&::before": {
            backgroundColor: "unset",
          },
        },
      }}
    >
      <Box
        sx={{
          backgroundColor: grey[100],
          p: 3,
        }}
      >
        <Grid container spacing={2}>
          {childrenWithEvents}
        </Grid>
      </Box>
    </CardExpanded>
  );
};
